export default "__VITE_ASSET__Iqimgr7A__"